<template lang="html">
  <div
    class="faculty"
    :class="{ active: showInfo && activeCourse !== null }"
    :key="faculty.uid"
  >
    <div class="faculty-col pb grid br">
      <h1
        class="p-h pt faculty-name link black"
        @click="(showInfo = !showInfo), (activeCourse = null)"
      >
        {{ faculty.title }}
      </h1>
      <div
        v-if="showInfo"
        class="faculty-info p-h gt"
        :class="{ pb: faculty.courses.length == 0 }"
      >
        <div v-if="faculty.images.length > 0" class="faculty-portrait">
          <img class="pht" :src="faculty.images[0].url" :alt="faculty.title" />
        </div>
        <div class="faculty-biography pr" v-html="faculty.biography" />
      </div>
      <div
        class="faculty-courses"
        v-if="courses.length > 0 && faculty.uid !== 'tristan-weddigen-prof-dr' && faculty.uid !== 'charlotte-matter-m-a'"
      >
        <div
          v-for="course in courses"
          :key="course.uid"
          :class="{ active: activeCourse === course.uid }"
        >
          <div class="link p-h" @click="toggleCourse(course.uid)">
            <div class="uc">
              <img
                v-if="activeCourse == course.uid"
                class="arrow up"
                src="./../assets/icons/arrow.svg"
              /><img
                v-if="activeCourse !== course.uid"
                class="arrow down"
                src="./../assets/icons/arrow.svg"
              />&nbsp; {{ course.title }} | {{ course.semester }}
            </div>
          </div>
          <div
            class="pt pl pr"
            v-if="activeCourse == course.uid && course.description"
            v-html="course.description"
          ></div>
          <div
            v-if="course.image.length > 0 && activeCourse == course.uid"
            class="faculty-image-side"
          >
            <img :src="course.image[0].url" :alt="course.title" />
            <figcaption
              v-if="course.image[0].caption"
              class="phl"
              v-html="course.image[0].caption"
            ></figcaption>
          </div>
        </div>
      </div>
      <div
        class="faculty-courses"
        v-if="courses.length > 0 && (faculty.uid === 'tristan-weddigen-prof-dr' || faculty.uid === 'charlotte-matter-m-a')"
      >
        <div
          v-for="course in faculty.courses"
          :key="course.uid"
          :class="{ active: activeCourse === course.uid }"
        >
          <div class="link p-h" @click="toggleCourse(course.uid)">
            <div class="uc">
              <img
                v-if="activeCourse == course.uid"
                class="arrow up"
                src="./../assets/icons/arrow.svg"
              /><img
                v-if="activeCourse !== course.uid"
                class="arrow down"
                src="./../assets/icons/arrow.svg"
              />&nbsp; {{ course.title }} | {{ course.semester }}
            </div>
          </div>
          <div
            class="p"
            v-show="activeCourse == course.uid"
            v-html="course.description"
          ></div>
          <div
            v-if="course.image.length > 0 && activeCourse == course.uid"
            class="faculty-image-side"
          >
            <img :src="course.image[0].url" :alt="course.title" />
            <figcaption
              v-if="course.image[0].caption"
              class="phl"
              v-html="course.image[0].caption"
            ></figcaption>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showInfo && activeCourse !== null" class="faculty-col side">
      <div class="faculty-image"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    faculty: Object
  },
  data() {
    return {
      showInfo: false,
      showCourseInfo: false,
      activeCourse: null
    };
  },
  computed: {
    courses() {
      let courses = this.$store.getters.getCoursesByUID(this.faculty.uid);
      return courses.reverse();
    }
  },
  methods: {
    toggleCourse(uid) {
      this.showInfo = true;
      if (this.activeCourse === uid) {
        this.activeCourse = null;
      } else {
        this.activeCourse = uid;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.faculty {
  position: relative;
  display: grid;
  page-break-inside: avoid;
  grid-template-columns: minmax(0, 1fr) minmax(0, calc(33% + 3px));
  overflow: hidden;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 100vw;
    .faculty-col {
      border-right: 0 !important;
    }
  }
  &:first-of-type {
    border-top: 0;
    .faculty-col {
      border-top: 0;
    }
  }
  &.active + .faculty {
    @media only screen and (min-width: 768px) {
      border-top: 1px solid black;
      .faculty-col {
        border-top: 0;
      }
    }
  }
  .faculty-col {
    position: relative;
    border-top: 1px solid black;
    &.grid {
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-rows: max-content;
      grid-gap: calc(0.5 * var(--lh));
    }
    &.side {
      height: calc(100% + 1px);
      overflow: hidden;
    }
  }
  .faculty-image-side {
    position: absolute;
    bottom: 0;
    height: 100%;
    left: calc(100% + 1px);
    width: calc(50% + 3px);
    overflow: hidden;
    opacity: 0.75;
    @media only screen and (max-width: 768px) {
      padding-top: calc(0.5 * var(--lh));
      position: relative;
      bottom: auto;
      left: auto;
      width: 100%;
    }
  }
  .faculty-image {
    width: 100%;
    height: auto;
    position: relative;
    img {
      width: 100%;
    }
    figcaption {
      width: 100%;
    }
  }
}
.link {
  &.active {
    color: black;
    padding-top: calc(0.5 * var(--lh));
    &:first-of-type {
      padding-top: 0;
    }
    &:last-of-type {
      .pv {
        padding-bottom: 0 !important;
      }
    }
  }
}
</style>
